export default {"src":"/_next/static/image/components/ui/Icon/icons/eye-close.995b726010c07d4c5d168859e5430a17.svg","height":16,"width":16};